import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// 1. requireLogin: If true, user must be logged in. If false (default), anyone can access.
// 2. requireRole: If set (e.g., 'admin'), user must have that role.
export default function ProtectedRoute({ children, requireLogin = true, requireRole = null }) {
    const { currentUser, userRole } = useAuth();

    if (requireLogin && !currentUser) {
        return <Navigate to="/login" replace />;
    }

    if (requireRole && userRole !== requireRole) {
        // If user is logged in but doesn't have the right role, 
        // maybe redirect to home or show "Not Authorized".
        // For now, redirect to home.
        return <Navigate to="/" replace />;
    }

    return children;
}
